interface FreeTrialAttentionEffectProps {
  shine?: boolean;
}

const FreeTrialAttentionEffect = ({
  shine = false,
}: FreeTrialAttentionEffectProps) => {
  return (
    <>
      {/* ring */}
      <span
        aria-hidden
        className="pointer-events-none absolute -inset-[2px] animate-[free-trial-attention-ring_1.2s_ease-out_infinite] rounded-[inherit] border-4 border-[#A98EFF]/90"
      />

      {/* shine */}
      {shine && (
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]"
        >
          <span className="absolute -left-[35%] top-1/2 h-[180%] w-[32%] -translate-y-1/2 rotate-[18deg] animate-[free-trial-attention-shine_3s_ease-in-out_infinite] bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.48),transparent)] blur-[3px]" />
        </span>
      )}
    </>
  );
};

export default FreeTrialAttentionEffect;
